import { FileIcon } from '@/assets/icons'
import { countLabel } from '@/utils/plural'
import React from 'react'
import { IndicatorButton } from './AttachmentIndicator.styles'

interface AttachmentIndicatorProps {
	count: number
	onClick: (e: React.MouseEvent) => void
}

const AttachmentIndicator: React.FC<AttachmentIndicatorProps> = ({ count, onClick }) => {
	if (count === 0) return null

	return (
		<IndicatorButton onClick={onClick}>
			<FileIcon />
			{countLabel(count, 'attachment')}
		</IndicatorButton>
	)
}

export default AttachmentIndicator
